<script>
    import Design2021ApprenticeDataTable from '../../common/design-2021-apprentice-data-table.vue';

    export default {
        name: 'design-2021-organization-edit-school-component',
        components: { Design2021ApprenticeDataTable },
        props: {
            lessonModulesIn: {
                type: Array,
                required: true
            },
            typesIn: {
                type: Array,
                required: false
            }
        },
        data() {
            return {
                school: null,
                display: false,
                lessonModules: [],
                searchTerm: null,
                fields: [
                    {
                        key: 'name',
                        sortable: true,
                        label: this.$t('common.name')
                    },
                    {
                        key: 'type_name',
                        label: this.$t('common.type'),
                        sortable: true
                    },
                    {
                        key: 'actions',
                        sortable: true,
                        label: this.$t('common.select')
                    }
                ],
                selectedLessonModules: null,
                filterType: 'all'
            };
        },
        methods: {
            show(school) {
                this.school = school;
                this.lessonModules = this.lessonModulesIn.map((module) => {
                    module.type_name = module.type?.name ?? null;
                    module.selected = !!this.school.lesson_modules.find((innerModule) => innerModule.id === module.id);
                    return module;
                });
                this.selectedLessonModules = this.lessonModulesIn.filter(lessonModule => lessonModule.selected);
                this.filterType = 'all';
                this.display = true;
            },
            save() {
                if (!this.selectedLessonModules.length) {
                    this.alert.confirm(this.$t('organization.school.remove.confirm_title'), this.$t('organization.school.remove.confirm_text')).then(
                        (confirm) => {
                            if (!confirm) {
                                return;
                            }

                            this.syncChanges();
                        });
                } else {
                    this.syncChanges();
                }
            },

            syncChanges() {
                let data = {
                    school_id: this.school.id,
                    lesson_modules: this.selectedLessonModules.map((lessonModule) => lessonModule.id)
                };
                this.alert.saving();
                this.axios.post(this.routes.lessonModuleSchool(), data).then(
                    (response) => {
                        this.$emit('school-synced', response.data);
                        this.alert.success();
                        this.back();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    }
                );
            },

            back() {
                this.display = false;
                this.$emit('back');
            },

            updateSelectedLessonModules(lessonModules) {
                this.selectedLessonModules = [...lessonModules];

                this.lessonModules.map(lessonModule => {
                    if (this.selectedLessonModules.map(selectedModule => selectedModule.id).includes(lessonModule.id)) {
                        lessonModule.selected = true;
                    } else {
                        lessonModule.selected = false;
                    }

                    return lessonModule;
                });
            },

            updateFilter(filter) {
                this.filterType = filter;
            }
        },
        computed: {
            filteredLessonModules() {
                let lessonModules = this.lessonModules;

                if (this.filterType !== 'all') {
                    lessonModules = lessonModules.filter(module => module.type_name === this.filterType);
                }

                return lessonModules;
            }
        }
    };
</script>

<template>
    <div class="organization-school-edit"
         v-if="display">
        <h3 class="title">
            {{ school?.name }}
        </h3>

        <div class="lesson-modules-wrapper">
            <design-2021-apprentice-picklist-component
                class="main-group-picklist"
                v-model="filteredLessonModules"
                :available-label="$t('organization.school.available_groups')"
                :enable-search="true"
                data-key="id"
                :selected-label="$t('organization.school.selected_groups')"
                @update="updateSelectedLessonModules">
                <template #options>
                    <div class="filter">
                        <b-dropdown
                            class="picklist-filter"
                            size="sm" variant="link"
                            toggle-class="text-decoration-none"
                            v-b-tooltip.hover
                            title="filter"
                            no-caret>
                            <template #button-content>
                                <i class="fas fa-filter filter-icon"></i>
                            </template>
                            <b-dropdown-text>
                                <h6 class="title">{{ $t('organization.school.picklist.filter.label') }}</h6>
                            </b-dropdown-text>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item :class="filterType === 'all' && 'active'"
                                             @click="updateFilter('all')">
                                {{ $t('organization.school.picklist.filter.all_text') }}
                            </b-dropdown-item>
                            <b-dropdown-item :class="filterType === type.name && 'active'"
                                             @click="updateFilter(type.name)"
                                             v-for="(type, index) in typesIn"
                                             :key="index">
                                {{ type.name }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </template>
            </design-2021-apprentice-picklist-component>
        </div>

        <div class="organization-edit-controls">
            <b-button variant="outline-primary" class="btn-back" @click="back">{{ $t('common.back') }}</b-button>
            <b-button variant="primary" class="btn-save" @click="save">{{ $t('common.save') }}</b-button>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .title {
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    }

    .picklist-filter ::v-deep {
        .dropdown-toggle {
            padding: map-get($grid-gutter-spacing, 'ten');
            font-size: $base-font-size;
            line-height: 1.5;
            background-color: var(--primary);
        }

        .dropdown-menu {
            .b-dropdown-text {
                margin-bottom: 0;
            }

            .title {
                margin-bottom: 0;
                font-weight: $font-weight-bold;
            }

            li {
                &:hover,
                &.active {
                    a {
                        background-color: var(--primary);
                        color: $white;
                        text-shadow: 0 0 var(--primary);
                    }
                }
            }
        }
    }

    .organization-edit-controls {
        display: flex;
        flex-wrap: wrap;
        gap: map-get($grid-gutter-spacing, 'ten') $grid-gutter-width;
        align-items: center;
        margin-top: map-get($grid-gutter-spacing, 'forty-two');
    }
</style>